import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import {List, Map} from "immutable";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import AlertRowDetail from '../../../components/common/AlertRowDetail'
import EditAlertDialog from "../../../components/dialogs/EditAlertDialog";

// Actions
import {getAlertTypes, updateAlertType, cleanAlertTypes} from "../../../actions/alert-types";

class AlertsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // Modal State
            canSubmit: false,
            modalIsOpen: false,
            modalType: null,
            modalData: ''
        };
    }
    componentDidMount() {
        this.props.getAlertTypes();
    }
    componentDidUpdate(prevProps, prevState) {
    }
    componentWillUnmount() {
        this.props.cleanAlertTypes();
    }

    // Get AlertType
    getAlertType = type => {
        const index = this.props.alertTypes.findIndex( alertType => alertType.get('name') === type );

        if (index !== -1) {
            return this.props.alertTypes.get(index);
        }
        else {
            return Map({})
        }
    };

    // Modal handlers
    onCanSubmit = canSubmit => {
        this.setState({
            canSubmit
        });
    };
    openModal = (modalType, modalData) => {
        this.setState({
            modalType,
            modalIsOpen: true,
            modalData
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false,
            canSubmit: false
        })
    };

    render() {

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'editAlertDialog':
                    modal = {
                        width: 'medium',
                        title: 'Editar Alerta',
                        body: (
                            <EditAlertDialog
                                onRef={ref => (this.child = ref)}
                                onCanSubmit={this.onCanSubmit}
                                onCloseModal={this.closeModal}
                                alertType={this.state.modalData}
                                updateAlertType={this.props.updateAlertType}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!this.state.canSubmit}
                                    onClick={ () => this.child.updateAlertType() }
                                >
                                    {'Guardar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center" style={{ height: 35 }} >
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                Configuración
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Alertas</strong>
                            </li>
                        </ol>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <h4>Alerta de stock</h4>
                                    <AlertRowDetail
                                        alertType={ this.getAlertType('stock') }
                                        openModal={this.openModal}
                                    />
                                    <h4>Alerta de rentabiliad de proyecto</h4>
                                    <AlertRowDetail
                                        alertType={ this.getAlertType('project_profit') }
                                        openModal={this.openModal}
                                    />
                                    <h4>Alerta de precio de productos</h4>
                                    <AlertRowDetail
                                        alertType={ this.getAlertType('product_price') }
                                        openModal={this.openModal}
                                        lastRow={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const alertTypesReducer = state.alertTypes;

    // AlertTypes
    let alertTypes = alertTypesReducer.get('payload') || List([]);

    if (!(alertTypes instanceof List)) {
        alertTypes = List([])
    }

    return {
        alertTypes
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAlertTypes: () => dispatch(getAlertTypes()),
        updateAlertType: (alertTypeId, alertType) => dispatch(updateAlertType(alertTypeId, alertType)),
        cleanAlertTypes: () => dispatch(cleanAlertTypes())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertsPage);



// WEBPACK FOOTER //
// ./src/containers/configuration/alerts/AlertsPage.js